import {RouterModule, Routes} from '@angular/router';
import {permission} from './thieme-catalog.permission';
import {ThiemeCatalogGridComponent} from './components/catalog-grid/thieme-catalog-grid.component';

const APP_ROUTES: Routes = [
  {
    path: 'module/thieme-catalog/grid',
    component: ThiemeCatalogGridComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_QUESTIONNAIRE_CREATE,
        permission.MYMEDAX_QUESTIONNAIRE_READ,
        permission.MYMEDAX_QUESTIONNAIRE_UPDATE,
        permission.MYMEDAX_QUESTIONNAIRE_DELETE
      ],
      needsConfig: [
        'feature.thieme'
      ]
    }
  }
];

export const routing = RouterModule.forRoot(APP_ROUTES);
